import { Options, Vue } from "vue-class-component";
import SideMenu from "../side-menu/index.vue";
import { MenuItem } from "../side-menu/side-menu";
import { Watch } from "vue-property-decorator";
import { RouteLocationNormalized } from "vue-router";
import NavigationBar from "../navigation-bar/index.vue";
import { NavItem, NavItemStatusID } from "../navigation-bar/navigation-item";
import PageHeader from "../page-header/index.vue";
import AlertBox from "../alert-box/index.vue";
import KitchensinkModal from "../kitchensink-modal/index.vue";
import { EventEmitter } from "events";
import store from "@/trust-admin-app/store";
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';

@Options({
  components: {
    SideMenu,
    NavigationBar,
    PageHeader,
    AlertBox,
    KitchensinkModal,
    DatePicker,
  }
})
export default class KitchenSink extends Vue {

  private dateRange = null;

  // menu items for side-menu
  private demoMenuItems: MenuItem[] = [
    { idx: 0, name: 'Practices', path: '', show: true },
    { idx: 1, name: 'Investigators', path: '', show: true },
    { idx: 2, name: 'Authorised signatures', path: '', show: true },
    { idx: 3, name: 'Investigation types', path: '', show: true },
    { idx: 4, name: 'Banks', path: '', show: true },
    { idx: 5, name: 'Accounting software', path: '', show: true },
  ];

  // dummy action  
  private menuAction(idx: number): void {
    console.log('Side menu: ', this.demoMenuItems[idx]);
  }
  @Watch('$route')
  public onRouteChanged(to: RouteLocationNormalized, from: RouteLocationNormalized): void {
    this.updateNavItems();
  }

  mounted(): void {
    this.updateNavItems();
  }

  private updateNavItems(): void {
    this.navItems.forEach((navItem) => {
      navItem.status = NavItemStatusID.NotCurrent;
      if (navItem.routeSecName === this.$route.name) {
        console.log(navItem.name, navItem.status);
        navItem.status = NavItemStatusID.Current;
      }
    });
  }

  private navItems: NavItem[] = [
    new NavItem('Home', 'home', null, true, NavItemStatusID.NotCurrent),
    new NavItem('KitchenSink', 'kitchen-sink', null, true, NavItemStatusID.Current),
    new NavItem('KitchenSink2', 'kitchen-sink2', null, true, NavItemStatusID.NotCurrent),
    new NavItem('KitchenSink3', 'kitchen-sink3', null, true, NavItemStatusID.NotCurrent),
  ];

  private showSaveAlertBox = false;
  private showKitchensinkModal = false;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  //   error
  //   background-color #f44336
  //   warning
  //   background-color #ff9800
  //   info
  //   background-color #2196f3
  //   success
  //   background-color #4caf50

  private showSnackbarError(): void {
    this.eventCtrl.emit('show-snackbar', 'error', 'Error message here');
  }

  private showSnackbarInfo(): void {
    this.eventCtrl.emit('show-snackbar', 'info', 'Info message');
  }

  private showSnackbarWarning(): void {
    this.eventCtrl.emit('show-snackbar', 'warning', 'Warning message here');
  }

  private showSnackbarSuccess(): void {
    this.eventCtrl.emit('show-snackbar', 'success', 'Success message here');
  }

}